import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=60d69870"
import script from "./Drag.vue?vue&type=script&lang=js"
export * from "./Drag.vue?vue&type=script&lang=js"
import style0 from "./Drag.vue?vue&type=style&index=0&id=60d69870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports